import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { FaYoutube, FaTiktok, FaInstagram, FaTwitter, FaFacebook } from 'react-icons/fa';

const PLATFORMS = [
    { name: 'YouTube', path: '/youtubedownloader', icon: FaYoutube, color: '#FF0000' },
    { name: 'Shorts', path: '/youtubeshortsdownloader', icon: FaYoutube, color: '#FF0000' },
    { name: 'TikTok', path: '/tiktokdownloader', icon: FaTiktok, color: '#eeba2c' },
    { name: 'Instagram', path: '/instagramdownloader', icon: FaInstagram, color: '#E1306C' },
    { name: 'Twitter', path: '/twitterdownloader', icon: FaTwitter, color: '#1DA1F2' },
    { name: 'Facebook', path: '/facebookdownloader', icon: FaFacebook, color: '#1877F2' },
];

export const PlatformNav = () => {
    const location = useLocation();
    const currentPath = location.pathname === '/' ? '/allvideodownloader' : location.pathname;

    return (
        <div className="platform-grid">
            {PLATFORMS.filter(p => p.path !== currentPath).map((platform) => (
                <Link to={platform.path} key={platform.name} className="platform-card">
                    <platform.icon className="platform-icon" style={{ color: platform.color }} />
                    <span className="platform-name">{platform.name}</span>
                </Link>
            ))}
        </div>
    );
};
